// ======================================================================
// File Name       : SystemNoticeList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Table, Form, Row } from 'react-bootstrap';
import { parseDateForDetail } from '../../utils/index';
import PaginationCustom from '../../components/Pagination';
import Header from '../../components/Header';
import { ROOT_URL, RETURN_MAX_NUM_TOP } from '../../constants/index';

class SystemNoticeList extends React.Component {
  render() {
    const { systemNotice, recordNumSystem, getStartEndDataSystem, startPositionSystem } = this.props;
    const noticeList = systemNotice.noticeList.map((notice, index) =>
      (<tr key={notice.noticeTitle + index}>
        <td>
        <a role="button" className="" onClick={this.props.onHandleNoticeDetail.bind(this, notice)}>
            {notice.noticeTitle}
        </a>
        </td>
        <td>{parseDateForDetail(notice.createdAt)}</td>
      </tr>),
    );
    return (
      <Col>
        <Col sm={12} className="padding-left-clear margin-top-20">
          <Row>
            <Col className="margin-left-15">
              <Header name="システムお知らせ一覧" />
            </Col>
            <Col xs="auto" className="mt-2 margin-top-20">
              <PaginationCustom
                recordNum={recordNumSystem}
                handlePageSelect={getStartEndDataSystem}
                startPosition={startPositionSystem}
                returnMaxNum={RETURN_MAX_NUM_TOP}
              />
            </Col>
          </Row>
          <Table striped hover>
            <thead>
              <tr>
                <th>お知らせ</th>
                <th>登録日</th>
              </tr>
            </thead>
            <tbody>
              {noticeList}
            </tbody>
          </Table>
        </Col>
      </Col>
    );
  }
}

export default SystemNoticeList;
